import { request } from '@wix/da-shared-react/pkg/xhr';
import { getModuleByModuleType as getModuleByModuleTypeNewGrusers } from '@wix/da-gruser-shared/pkg/redux/selectors/modules';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { API_BASE_PATH } from '../../constants';
import { getProfileGruser, getProfileOwnerUser } from '../selectors/users';

import { runModuleInitActions } from './modules';

import {
  getModuleIdByModuleType,
  getModuleVersion,
} from '../selectors/modules';
import { ModuleType } from '../../types/modules';
import { SagaIterator } from 'redux-saga';
import {
  getProfileHeroCropArea,
  getProfileHeroDeviation,
} from '../selectors/profileHeroEditor';
import {
  saveProfileHero,
  deleteProfileHero,
  setIsRepositioningProfileHero,
} from '../actions/profileHeroEditor';
import { getSourceImageRatio } from '@wix/da-shared-react/pkg/DeviationViews/Dumbo/Image/_helpers';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags/selectors';
import { fetchModuleEndpoint } from '@wix/da-gruser-shared/pkg/redux/actions/modules';

function* save(data) {
  const deviation_gruser_flag = yield select(flagEnabled, 'deviation_gruser');
  const gruser = yield select(getProfileGruser);

  if (deviation_gruser_flag) {
    yield put(
      fetchModuleEndpoint(gruser!, {
        ...data,
        id: data.moduleid,
        path: 'cover_deviation/save',
        method: 'post',
      })
    );
    yield put(setIsRepositioningProfileHero(false));
    return;
  }

  return yield call(request, {
    method: 'post',
    baseURL: API_BASE_PATH,
    url: `/module/cover_deviation/save`,
    data,
  });
}

export function* saveProfileHeroSaga(): SagaIterator {
  let moduleId;
  let moduleVersion;
  const deviation_gruser_flag = yield select(flagEnabled, 'deviation_gruser');
  if (deviation_gruser_flag) {
    const gruser = yield select(getProfileGruser);
    const module = yield select(
      getModuleByModuleTypeNewGrusers,
      gruser,
      'coverDeviation'
    );
    moduleId = module.id;
    moduleVersion = module.version;
  } else {
    moduleId = yield select(
      getModuleIdByModuleType,
      ModuleType.COVER_DEVIATION
    );
    moduleVersion = yield select(getModuleVersion, moduleId);
  }

  const version = moduleVersion;
  const { username } = yield select(getProfileOwnerUser);

  const deviation = yield select(getProfileHeroDeviation);
  const originalImageRatio = getSourceImageRatio(deviation);
  const cropArea = yield select(getProfileHeroCropArea);
  const cropAreaPapiParams = cropArea
    ? {
        image_width: cropArea.width,
        image_height: Math.round(cropArea.width / originalImageRatio),
        crop_x: cropArea.x,
        crop_y: cropArea.y,
        crop_width: cropArea.width,
        crop_height: cropArea.height,
      }
    : {};

  const response = yield call(save, {
    moduleid: moduleId,
    // Even though this expects a number and we're passing through the normalized
    // deviation id (which could be number | string), it should only ever receive
    // a deviation that production an id of type number
    deviationid: deviation.deviationId,
    ...cropAreaPapiParams,
    version,
    username,
  });

  if (response && response.moduleData) {
    yield call(runModuleInitActions, response);
    yield put(setIsRepositioningProfileHero(false));
  }
}

export function* deleteProfileHeroSaga() {
  let moduleId;
  let moduleVersion;
  const deviation_gruser_flag = yield select(flagEnabled, 'deviation_gruser');
  if (deviation_gruser_flag) {
    const gruser = yield select(getProfileGruser);
    const module = yield select(
      getModuleByModuleTypeNewGrusers,
      gruser,
      'coverDeviation'
    );
    moduleId = module.id;
    moduleVersion = module.version;
  } else {
    moduleId = yield select(
      getModuleIdByModuleType,
      ModuleType.COVER_DEVIATION
    );
    moduleVersion = yield select(getModuleVersion, moduleId);
  }
  const { username } = yield select(getProfileOwnerUser);
  const response = yield call(save, {
    moduleid: moduleId,
    deviationid: 0,
    version: moduleVersion,
    username,
  });

  if (response && response.moduleData) {
    yield call(runModuleInitActions, response);
  }
}

export default function* rootCoverDeviationSaga() {
  yield all([
    takeEvery(saveProfileHero, saveProfileHeroSaga),
    takeEvery(deleteProfileHero, deleteProfileHeroSaga),
  ]);
}
